import { render, staticRenderFns } from "./PcWeb.vue?vue&type=template&id=31405b76"
import script from "./PcWeb.vue?vue&type=script&lang=js"
export * from "./PcWeb.vue?vue&type=script&lang=js"
import style0 from "./PcWeb.vue?vue&type=style&index=0&id=31405b76&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports